<!-- Loader global -->
<div class="loading-overlay" *ngIf="isLoading">
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <p class="loader-text">Chargement en cours...</p>
  </div>
</div>

<div class="min-h-screen bg-white">
  <div class="max-w-full mx-auto py-6">
        <!-- Crédit si utilisateur -->
        <div *ngIf="!isAdmin && !isSousAdmin" class="mb-6">
          <app-credit-disponible></app-credit-disponible>
        </div>

        <!-- Conteneur principal -->
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <!-- Header -->
          <div class="px-6 py-4 border-b border-gray-200 bg-white">
            <div class="flex items-center justify-between flex-wrap gap-4">
              <div class="flex items-center gap-3">
                <div class="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                  <span class="material-symbols-outlined text-white text-lg">dashboard</span>
                </div>
                <div>
                  <h1 class="text-2xl font-bold text-gray-900">Dashboard</h1>
                  <p class="text-sm text-gray-600 mt-0.5">Vue d'ensemble en temps réel</p>
                </div>
              </div>
              <div class="flex items-center gap-4 flex-wrap">
                <div class="flex items-center gap-2 bg-gray-50 px-3 py-2 rounded-lg border border-gray-200">
                  <span class="text-lg">🖥️</span>
                  <div>
                    <div class="text-lg font-bold text-gray-900">{{ devices.length }}</div>
                    <div class="text-xs text-gray-600 uppercase tracking-wide">Machines</div>
                  </div>
                </div>
                <div class="flex items-center gap-2 bg-gray-50 px-3 py-2 rounded-lg border border-gray-200">
                  <span class="text-lg">📣</span>
                  <div>
                    <div class="text-lg font-bold text-gray-900">{{ campagnesEnPlay.length }}</div>
                    <div class="text-xs text-gray-600 uppercase tracking-wide">Campagnes</div>
                  </div>
                </div>
                <div class="flex items-center gap-2 bg-gray-50 px-3 py-2 rounded-lg border border-gray-200">
                  <span class="text-lg">⚡</span>
                  <div>
                    <div class="text-lg font-bold text-gray-900">{{ getActiveMachinesCount() }}</div>
                    <div class="text-xs text-gray-600 uppercase tracking-wide">Actives</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Contenu -->
          <div class="p-6">
            <!-- Sélection de la vue -->
            <div class="mb-6">
              <div class="flex items-center gap-3">
                <label class="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <span class="text-lg">📊</span>
                  Vue
                </label>
                <select 
                  class="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm bg-white cursor-pointer"
                  [(ngModel)]="selectedView" 
                  (ngModelChange)="onViewChange()">
                  <option value="stats">📈 Statistiques</option>
                  <option value="machines">🖥️ Machines</option>
                </select>
              </div>
            </div>

            <!-- Vue Statistiques -->
            <div *ngIf="selectedView === 'stats'" class="space-y-6">
              <!-- Sélection du device -->
              <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div class="flex flex-col gap-2">
                  <label class="flex items-center gap-2 text-sm font-semibold text-gray-700">
                    <span class="text-lg">🖥️</span>
                    Sélectionner une machine
                  </label>
                  <select 
                    class="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm bg-white cursor-pointer"
                    [(ngModel)]="selectedDeviceForStats" 
                    (ngModelChange)="onDeviceForStatsChange()">
                    <option [value]="null">-- Sélectionner une machine --</option>
                    <option *ngFor="let device of devices" [value]="device._id">{{ device.name }}</option>
                  </select>
                </div>
              </div>

              <!-- Stats du device sélectionné -->
              <div *ngIf="selectedDeviceForStats && statsData.deviceStats" class="space-y-6">
                <!-- Résumé général -->
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div class="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                    <div class="flex items-center gap-4">
                      <div class="w-16 h-16 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
                        <span class="text-3xl">📱</span>
                      </div>
                      <div class="flex-1">
                        <div class="text-xs text-gray-600 uppercase tracking-wide mb-1">Numéros récupérés</div>
                        <div class="text-3xl font-bold text-gray-900">{{ statsData.deviceStats.totalPhoneNumbers }}</div>
                        <div class="text-xs text-gray-500 mt-1">sur {{ statsData.deviceStats.totalChips }} puces</div>
                      </div>
                    </div>
                  </div>
                  <div class="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                    <div class="flex items-center gap-4">
                      <div class="w-16 h-16 bg-green-50 rounded-lg flex items-center justify-center flex-shrink-0">
                        <span class="text-3xl">💬</span>
                      </div>
                      <div class="flex-1">
                        <div class="text-xs text-gray-600 uppercase tracking-wide mb-1">SMS envoyés (total)</div>
                        <div class="text-3xl font-bold text-gray-900">{{ statsData.deviceStats.totalSms | number }}</div>
                        <div class="text-xs text-gray-500 mt-1">tous slots confondus</div>
                      </div>
                    </div>
                  </div>
                  <div class="bg-white rounded-lg p-6 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                    <div class="flex items-center gap-4">
                      <div class="w-16 h-16 bg-red-50 rounded-lg flex items-center justify-center flex-shrink-0">
                        <span class="text-3xl">⚰️</span>
                      </div>
                      <div class="flex-1">
                        <div class="text-xs text-gray-600 uppercase tracking-wide mb-1">Puces mortes</div>
                        <div class="text-3xl font-bold" 
                             [class.text-red-600]="statsData.deviceStats.deadRatio > 50"
                             [class.text-amber-600]="statsData.deviceStats.deadRatio > 25 && statsData.deviceStats.deadRatio <= 50"
                             [class.text-gray-900]="statsData.deviceStats.deadRatio <= 25">
                          {{ statsData.deviceStats.deadRatio }}%
                        </div>
                        <div class="text-xs text-gray-500 mt-1">{{ statsData.deviceStats.deadChips }} / {{ statsData.deviceStats.totalChips }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Numéros de téléphone récupérés par jour -->
                <div class="bg-white rounded-lg p-6 border border-gray-200 shadow-sm">
                  <div class="flex items-center justify-between mb-6 pb-4 border-b border-gray-200">
                    <div class="flex items-center gap-4">
                      <div class="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center">
                        <span class="text-2xl">📱</span>
                      </div>
                      <div>
                        <h3 class="text-lg font-bold text-gray-900">Numéros de téléphone récupérés</h3>
                        <p class="text-sm text-gray-600 mt-0.5">Répartition sur les 7 derniers jours</p>
                      </div>
                    </div>
                    <div class="text-right">
                      <div class="text-2xl font-bold text-blue-600">{{ statsData.deviceStats.totalPhoneNumbers }}</div>
                      <div class="text-xs text-gray-600 uppercase tracking-wide">Total</div>
                    </div>
                  </div>
                  <div class="grid grid-cols-7 gap-4">
                    <div *ngFor="let day of statsData.phoneNumbersByDay" class="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:bg-gray-100 transition-colors">
                      <div class="flex items-center justify-between mb-3">
                        <span class="text-xs font-semibold text-gray-700 uppercase">{{ day.day }}</span>
                        <span class="text-lg font-bold text-gray-900">{{ day.value }}</span>
                      </div>
                      <div class="w-full h-2 bg-gray-200 rounded-full overflow-hidden mb-2">
                        <div class="h-full bg-blue-600 rounded-full transition-all" [style.width.%]="day.percentage"></div>
                      </div>
                      <div class="text-xs text-gray-500 text-center">{{ day.percentage | number:'1.0-0' }}%</div>
                    </div>
                  </div>
                </div>

                <!-- SMS envoyés par heure -->
                <div class="bg-white rounded-lg p-6 border border-gray-200 shadow-sm">
                  <div class="flex items-center justify-between mb-6 pb-4 border-b border-gray-200">
                    <div class="flex items-center gap-4">
                      <div class="w-12 h-12 bg-green-50 rounded-lg flex items-center justify-center">
                        <span class="text-2xl">💬</span>
                      </div>
                      <div>
                        <h3 class="text-lg font-bold text-gray-900">SMS envoyés par heure</h3>
                        <p class="text-sm text-gray-600 mt-0.5">Répartition sur 24 heures</p>
                      </div>
                    </div>
                    <div class="text-right">
                      <div class="text-2xl font-bold text-green-600">{{ statsData.deviceStats.totalSmsHeure | number }}</div>
                      <div class="text-xs text-gray-600 uppercase tracking-wide">Total/heure</div>
                    </div>
                  </div>
                  <div class="grid grid-cols-12 gap-3">
                    <div *ngFor="let hour of statsData.smsByHour" class="bg-gray-50 rounded-lg p-3 border border-gray-200 hover:bg-gray-100 transition-colors flex flex-col items-center gap-2">
                      <div class="text-xs font-semibold text-gray-600">{{ hour.hour }}h</div>
                      <div class="text-base font-bold text-gray-900">{{ hour.value | number }}</div>
                      <div class="w-full h-16 bg-gray-200 rounded-lg overflow-hidden flex items-end">
                        <div class="w-full bg-green-600 rounded-lg transition-all min-h-[4px]" [style.height.%]="hour.percentage"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Message si aucun device sélectionné -->
              <div *ngIf="!selectedDeviceForStats" class="bg-white rounded-lg p-12 border border-gray-200 shadow-sm text-center">
                <div class="text-6xl mb-4 opacity-50">📊</div>
                <p class="text-base text-gray-600">Sélectionnez une machine pour afficher ses statistiques</p>
              </div>
            </div>

            <!-- Vue Machines -->
            <div *ngIf="selectedView === 'machines'" class="space-y-6">
              <!-- Filtres et sélection des machines -->
              <div class="bg-gray-50 rounded-lg p-4 border border-gray-200 space-y-4">
                <!-- Filtre de mode d'affichage -->
                <div class="flex flex-col gap-2">
                  <label class="flex items-center gap-2 text-sm font-semibold text-gray-700">
                    <span class="text-lg">🎯</span>
                    Mode d'affichage
                  </label>
                  <select 
                    class="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm bg-white cursor-pointer"
                    [(ngModel)]="selectedDisplayMode" 
                    (ngModelChange)="onDisplayModeChange()">
                    <option value="phoneNumber">Numéro de téléphone</option>
                    <option value="totalEnvoi">Envoi total</option>
                    <option value="totalEnvoiHeure">Envoi total / heure</option>
                    <option value="totalEnvoiJour">Envoi total / jour</option>
                    <option value="revenuGeneratedReception">Revenu généré réception</option>
                    <option value="portStatus">Statut des ports</option>
                  </select>
                </div>

                <!-- Sélection des 2 machines -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div *ngFor="let index of [0, 1]" class="flex flex-col gap-2">
                    <label class="flex items-center gap-2 text-sm font-semibold text-gray-700">
                      <span class="text-lg">🖥️</span>
                      Machine {{ index + 1 }}
                    </label>
                    <select 
                      class="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm bg-white cursor-pointer"
                      [ngModel]="selectedMachines[index]" 
                      (ngModelChange)="onMachineChange(index, $event)"
                      [compareWith]="compareDeviceIds">
                      <option [ngValue]="null">-- Sélectionner --</option>
                      <option *ngFor="let device of devices" [ngValue]="device._id">{{ device.name }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Statistiques des machines sélectionnées -->
              <div *ngIf="hasSelectedMachines()" class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div *ngFor="let machineData of machinesData" class="bg-white rounded-lg p-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                  <div class="flex items-center justify-between mb-4 pb-3 border-b border-gray-200">
                    <h3 class="text-base font-semibold text-gray-900">{{ getMachineName(machineData.deviceId) }}</h3>
                    <span class="px-3 py-1 rounded-full text-xs font-semibold"
                          [class.bg-green-100]="machineData.device?.isUsed"
                          [class.text-green-800]="machineData.device?.isUsed"
                          [class.bg-red-100]="!machineData.device?.isUsed"
                          [class.text-red-800]="!machineData.device?.isUsed">
                      {{ machineData.device?.isUsed ? '✅ Active' : '⛔ Inactive' }}
                    </span>
                  </div>
                  <div class="space-y-2">
                    <div class="flex items-center justify-between py-2">
                      <span class="text-sm text-gray-600">📱 Tél. récupérés</span>
                      <span class="text-base font-semibold text-gray-900">{{ machineData.stats?.nbDeTelRecupere || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between py-2">
                      <span class="text-sm text-gray-600">📊 Envoi total</span>
                      <span class="text-base font-semibold text-gray-900">{{ machineData.stats?.envoiTotal || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between py-2">
                      <span class="text-sm text-gray-600">📈 Envoi / jour</span>
                      <span class="text-base font-semibold text-gray-900">{{ machineData.stats?.envoiTotalJour || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between py-2">
                      <span class="text-sm text-gray-600">⏰ Envoi / heure</span>
                      <span class="text-base font-semibold text-gray-900">{{ machineData.stats?.envoiTotalHeure || 0 }}</span>
                    </div>
                    <div *ngIf="selectedDisplayMode === 'revenuGeneratedReception'" class="flex items-center justify-between py-2">
                      <span class="text-sm text-gray-600">💰 Revenu réception</span>
                      <span class="text-base font-semibold text-gray-900">{{ machineData.stats?.revenuTotalGeneratedReception || 0 | number:'1.2-2' }} $</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tableaux des machines (3 colonnes) -->
              <div *ngIf="hasSelectedMachines()" class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div *ngFor="let machineData of machinesData" class="bg-white rounded-lg p-4 border border-gray-200 shadow-sm">
                  <div class="mb-3 pb-3 border-b border-gray-200">
                    <h3 class="text-base font-semibold text-gray-900 mb-1">{{ getMachineName(machineData.deviceId) }}</h3>
                    <span class="text-xs text-gray-600">{{ machineData.device?.nbPorts || 0 }} ports × {{ machineData.device?.nbSlots || 0 }} slots</span>
                  </div>
                  <div class="w-full overflow-x-auto">
                    <table class="w-full border-collapse text-[7px] table-fixed m-auto">
                      <thead>
                        <tr>
                          <th class="px-1 py-1 text-center font-semibold text-gray-700 border border-gray-300 bg-gray-50">Port</th>
                          <th *ngFor="let slot of getSlotNumbers(machineData.device)" class="px-1 py-1 text-center font-semibold text-gray-700 border border-gray-300 bg-gray-50">{{ slot }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let port of getPortNumbers(machineData.device)">
                          <td class="px-1 py-1 text-center font-semibold text-gray-700 border border-gray-300 bg-gray-50 w-[26px] text-[7px]">{{ port }}</td>
                          <td *ngFor="let slot of getSlotNumbers(machineData.device)" 
                              [class]="getCellClass(machineData, port, slot)"
                              [title]="getCellTitle(machineData, port, slot)"
                              (click)="onCellClick(machineData, port, slot)"
                              [style.cursor]="shouldShowIndicator() ? 'pointer' : 'default'"
                              class="table-cell px-0 py-0 text-center border border-gray-300 transition-all w-[20px] h-[14px]">
                            <!-- Indicateur pour phoneNumber ou portStatus -->
                            <div *ngIf="shouldShowIndicator() && (selectedDisplayMode !== 'phoneNumber' || hasValidPhoneNumber(machineData, port, slot))" 
                                 class="table-cell-indicator"></div>
                            <!-- Valeur pour les autres modes -->
                            <span *ngIf="!shouldShowIndicator()" 
                                  class="cell-content block overflow-hidden text-ellipsis whitespace-nowrap text-[6px] leading-tight p-0 max-w-full">{{ getCellValue(machineData, port, slot) }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</div>
